export const fallbackTranslation = {
  fallback: {
    'ERRORBOUNDARY.FALLBACK.PART1':
      'The {0} page has encountered an unexpected error and our team has been notified.',
    'ERRORBOUNDARY.FALLBACK.PART2': 'Please refresh the page and try again.',
  },
};
